module.exports = __webpack_public_path__ + "img/20_69.df14fec0.png";